"use strict";

define('view/message.template/message.template.detail',['require','exports','module','uikit/uikit','../../templates','langs'],function (require, exports, module) {
  var UIKit = require('uikit/uikit');
  var Templates = require('../../templates');
  var langs = require('langs');
  var MessageTemplateDetailView = Mn.ItemView.extend(UIKit.ComponentMixin).extend({
    template: Templates.IRB['message.template.detail'],
    options: {
      sectionTitle: langs.phrase('Settings.MessageTemplates.Details.Title')
    },
    internalViews: {
      breadcrumb: UIKit.Breadcrumb,
      save: UIKit.Button,
      preview: UIKit.Button,
      revert: UIKit.Button,
      header: UIKit.Header
    }
  });
  module.exports = MessageTemplateDetailView;
});

